import React from 'react';

const Buttonbar = (props) => {
  const getButtonClass = (viewType, isFirst, isLast) =>
    `flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border 
    ${isFirst ? 'rounded-l' : isLast ? 'rounded-r' : 'border-t border-b border-r'} 
    ${viewType === props.viewType ? 'text-summary-header bg-green' : 'text-summary-header'} 
    border-green-gray hover:text-summary-header`;

  const buttons = props.isDisplayDaily
    ? [
        { key: 'daily', label: 'daily', viewType: 'daily' },
        { key: '7_days', label: '7_days', viewType: 'weekly' },
        { key: '4_weeks', label: '4_weeks', viewType: 'monthly' },
        { key: '1_year', label: '1_year', viewType: 'yearly' }
      ]
    : [
        { key: '7_days', label: '7_days', viewType: 'week' },
        { key: '4_weeks', label: '4_weeks', viewType: 'month' },
        { key: '1_year', label: '1_year', viewType: 'year' }
      ];

  return (
    <nav className='flex ml-0 md:ml-9 lg:ml-9 xl:ml-9'>
      {buttons.map(({ key, label, viewType }, index) => (
        // eslint-disable-next-line
        <a
          key={key}
          className={getButtonClass(viewType, index === 0, index === buttons.length - 1)}
          onClick={() => props.onChangePeriod(viewType)}
        >
          {props.t(label)}
        </a>
      ))}
    </nav>
  );
};


export default Buttonbar;
